export default __webpack_public_path__ + "static/media/heroku_logo.4d794195.png";